module.exports = __webpack_public_path__ + "static/media/0003.3e355dd4.jpg";